import client from '../client'

export const getStatesKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/GetStates`

export async function getStates() {
  return client(getStatesKey)
}
